import {GET_ASSESSMENT_LIST, GET_ASSESSMENT_LIST_SUCCESS, GET_ASSESSMENT_LIST_FAILED,
    SEARCH_QUESTION_FROM_QUESTION_BANK,SEARCH_QUESTION_FROM_QUESTION_BANK_SUCCESS,SEARCH_QUESTION_FROM_QUESTION_BANK_FAIL,
    UPDATE_ACTIVITY_STATUS,UPDATE_ACTIVITY_STATUS_SUCCESS,UPDATE_ACTIVITY_STATUS_FAIL,
    GET_VIEW_ASSESSMENT_LIST, GET_VIEW_ASSESSMENT_LIST_SUCCESS,GET_VIEW_ASSESSMENT_LIST_FAIL,
    POST_SELECTED_QUESTION,POST_SELECTED_QUESTION_SUCCESS, POST_SELECTED_QUESTION_FAIL,
    UPDATE_SELECTED_QUESTION
  } from "./actionTypes";
  
    export const getAssesmentList = (data) => {
      return {
        type: GET_ASSESSMENT_LIST,
        payload: data,
      };
    };
    export const getAssesmentListSuccess = (questions) => {
      return {
        type: GET_ASSESSMENT_LIST_SUCCESS,
        payload: questions,
      };
    };
    export const getAssesmentListFailed = (error) => {
      return {
        type: GET_ASSESSMENT_LIST_FAILED,
        payload: error,
      };
    };
  
    //view question list
    export const viewAssesmentquestions = (data) => {
      return {
        type: GET_VIEW_ASSESSMENT_LIST,
        payload: data,
      };
    };
    export const viewAssesmentquestionsSuccess = (questions) => {
      return {
        type: GET_VIEW_ASSESSMENT_LIST_SUCCESS,
        payload: questions,
      };
    };
    export const viewAssesmentquestionsFailed = (error) => {
      return {
        type: GET_VIEW_ASSESSMENT_LIST_FAIL,
        payload: error,
      };
    };
  
    //update activity
    export const changeAssessmentStatus = (data) => {
      return {
        type:UPDATE_ACTIVITY_STATUS,
        payload: data,
      };
    };
    export const changeAssessmentStatusSuccess = (message) => {
      return {
        type: UPDATE_ACTIVITY_STATUS_SUCCESS,
        payload: message,
      };
    };
    export const changeAssessmentStatusFailed = (message) => {
      return {
        type: UPDATE_ACTIVITY_STATUS_FAIL,
        payload: message,
      };
    };
  
    //post selected questions
    export const postSelectedAssesmentQuestion = (data) => {
      return {
        type: POST_SELECTED_QUESTION,
        payload: data,
      };
    };
  
    export const updateSelectedAssesmentQuestion = (data) => {
      return {
        type: UPDATE_SELECTED_QUESTION,
        payload: data,
      };
    };
  
    export const postSelectedAssesmentQuestionsuccess = (questions) => {
      return {
        type: POST_SELECTED_QUESTION_SUCCESS,
        payload: questions,
      };
    };
    export const postSelectedAssesmentQuestionFailed = (error) => {
      return {
        type:  POST_SELECTED_QUESTION_FAIL,
        payload: error,
      };
    };
  
  
    //search question add questions page
    export const searchQuestions = (data) => {
      return {
        type: SEARCH_QUESTION_FROM_QUESTION_BANK,
        payload: data,
      };
    };
    export const searchQuestionssuccess = (questions) => {
      return {
        type: SEARCH_QUESTION_FROM_QUESTION_BANK_SUCCESS,
        payload: questions,
      };
    };
    export const searchQuestionsFailed = (error) => {
      return {
        type: SEARCH_QUESTION_FROM_QUESTION_BANK_FAIL,
        payload: error,
      };
    };
  